export type PricingItem = { label: string, included: boolean, note?: string }

export const FREE_PRICING_ITEMS: PricingItem[] = [
  { label: 'Email Support', included: true },
  { label: 'Automatic Reminders', included: true },
  { label: 'Unlimited Clients', included: true },
  { label: 'Unlimited Emails', included: false, note: 'Max 3 per day' },
  { label: 'Unlimited Invoices', included: false, note: 'Max 30' },
]

export const PRO_PRICING_ITEMS: PricingItem[] = [
  { label: 'Email Support', included: true },
  { label: 'Automatic Reminders', included: true },
  { label: 'Unlimited Clients', included: true },
  { label: 'Unlimited Emails', included: true },
  { label: 'Unlimited Invoices', included: true },
]

/** Reference USD prices shown on the static pricing page (live checkout uses Stripe). */
export const STATIC_USD_MONTHLY = '$5.99'
export const STATIC_USD_YEARLY = '$49.99'
export const STATIC_YEARLY_SAVINGS_PERCENT = 30
